import {
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { addQuestionair, getAllTeachers } from '../repo/firebaseFunctions';
import axios from '../services/axios';

const Questionnaire = (props) => {
  const [isLoading, setIsLoading] = useState(true);

  const [teachers, setTeachers] = React.useState([]);
  const [selectedTeacher, setSelectedTeacher] = React.useState(null);
  const [formData, setFormData] = React.useState({
    teacherUUID: '',
    recommendation: '',
    improvement: '',
    suggestion: '',
    rating: '',
  });

  useEffect(() => {
    fetchTeachers();

  }, []);

  const fetchTeachers = async () => {
    const teachers = await getAllTeachers("001")
    setTeachers(teachers);
    setIsLoading(false);

  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedTeacher) return alert('Please select a teacher to review');

    let score = 0
    let mapRating = {"Excellent" : 3,"Very Good" : 2,"Good" : 1,"Fair" : 0}
    let mapReccomendation = {"Definitely" : 3,"Probably" : 2,"Not Sure" : 1,"Probably Not" : 0}

    score = mapRating[formData.rating] + mapReccomendation[formData.recommendation]
    let percentage = (score/6)*100;
     const selectedTeacherObj = (teachers.find((e) => {
      return e.name == selectedTeacher
    }))
    console.log(selectedTeacherObj.id)
    await addQuestionair('001', selectedTeacherObj.id, percentage, formData.suggestion ?? "N/A" ).then((value)=> {
      if(value == true){
        alert('Submitted Successfully')
      }else{
        alert('Something went worng')
      }
    })

  };

  return (
    isLoading ? 
            <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '30%' }}>
            <CircularProgress />
          </div>:
    <div
      style={{
        width: '40%',
        margin: 'auto',
      }}
    >
      <div
        style={{
          backgroundColor: '#27A6B2',
          padding: '20px 15px',
          color: 'white',
        }}
      >
        <h1>TEACHER REVIEW QUESTIONNAIRE</h1>
      </div>

      <form onSubmit={handleSubmit}>
        <div
          style={{
            backgroundColor: '#FFFFFF',
            padding: '20px 15px',
          }}
        >
          <p>1. Please select the teacher to review?:</p>
          <FormControl fullWidth>
            <InputLabel id='demo-simple-select-label'>Select Teacher </InputLabel>
            
        


            <Select id='teacher' name='teacher' label='Teacher' onChange={(event) => {
                const { value } = event.target;
                setSelectedTeacher(value);
              }}>
            {
                //loop over classesData and return a MenuItem for each class
                teachers.map((teacher) => {
                    return <MenuItem value={teacher.name}>{teacher.name}</MenuItem>
                }
                )
            }

            </Select>

          </FormControl>

          <p>2. Overall, how would you rate this teacher?:</p>
          <ul
            style={{
              listStyleType: 'none',
            }}
          >
            <li>
              <input
                onChange={(event) => {
                  const { value, name } = event.target;
                  setFormData({ ...formData, [name]: value });
                }}
                type='radio'
                id='1'
                name='rating'
                value='Excellent'
                required
              />
              Excellent
            </li>

            <li>
              <input
                onChange={(event) => {
                  const { value, name } = event.target;
                  setFormData({ ...formData, [name]: value });
                }}
                type='radio'
                id='2'
                name='rating'
                value='Very Good'
                required
              />
              Very Good
            </li>

            <li>
              <input
                onChange={(event) => {
                  const { value, name } = event.target;
                  setFormData({ ...formData, [name]: value });
                }}
                type='radio'
                id='3'
                name='rating'
                required
                value='Good'
              />
              Good
            </li>

            <li>
              <input
                onChange={(event) => {
                  const { value, name } = event.target;
                  setFormData({ ...formData, [name]: value });
                }}
                type='radio'
                id='4'
                name='rating'
                value='Fair'
                required
              />
              Fair
            </li>
          </ul>

          <p>3. Would you recommend this teacher to other students?:</p>
          <ul
            style={{
              listStyleType: 'none',
            }}
          >
            <li>
              <input
                onChange={(event) => {
                  const { value, name } = event.target;
                  setFormData({ ...formData, [name]: value });
                }}
                type='radio'
                id='5'
                name='recommendation'
                value='Definitely'
                required
              />
              Definitely
            </li>

            <li>
              <input
                onChange={(event) => {
                  const { value, name } = event.target;
                  setFormData({ ...formData, [name]: value });
                }}
                type='radio'
                id='6'
                name='recommendation'
                value='Probably'
                required
              />
              Probably
            </li>

            <li>
              <input
                onChange={(event) => {
                  const { value, name } = event.target;
                  setFormData({ ...formData, [name]: value });
                }}
                type='radio'
                id='7'
                name='recommendation'
                value='Not Sure'
                required
              />
              Not sure
            </li>

            <li>
              <input
                onChange={(event) => {
                  const { value, name } = event.target;
                  setFormData({ ...formData, [name]: value });
                }}
                type='radio'
                id='8'
                name='recommendation'
                value='Probably Not'
                required
              />
              Probably Not
            </li>

          </ul>

          <p>4. Do you have any suggestions for improvement?:</p>
          <textarea
            onChange={(event) => {
              const { value, name } = event.target;
              setFormData({ ...formData, [name]: value });
            }}
            name='suggestion'
            id='suggestion'
            rows={10}
            cols={50}
          />

          <br />

          <Button type='submit' variant='contained'>
            Submit
          </Button>
        </div>
      </form>
    </div>
  );
};

export default Questionnaire;
